import axios from 'axios';
import { NullableRecords } from 'types/_common';

export type PermissionInListDTO = NullableRecords<{
  permission: NullableRecords<{
    sysName: string;
  }>;
  organizationId: number;
}>;

export const fetchPermissionList = async ({
  personId,
}: {
  personId?: number;
}): Promise<NullableRecords<{
  data: NullableRecords<{
    permissions: PermissionInListDTO[];
    orgChilds: NullableRecords<{
      childs: number[];
      organizationId: number;
    }>[];
  }>;
}>> => {
  const response = await axios.get('/api/rest/permission/list/new', { params: { personId } });
  return response.data;
};
